module.exports = __webpack_public_path__ + "static/shield_of_missile_attraction-a78a1ed2d5ecbcbbc0efe8907a734278.jpeg";